import CheckboxBlankCircleLine from '@/assets/icons/ri_checkbox_blank_circle_line.svg?component';
import CheckboxCircleLine from '@/assets/icons/ri_checkbox_circle_line.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import Tooltip from '@/components/atoms/Tooltip';
import { alertIconColors } from '@/config/settings';

interface BooleanStatusIconProps {
    active: boolean;
    activeLabel: string;
    inactiveLabel: string;
}

/** A filled or empty circle for a yes/no column, with the answer spelled out on hover. */
export default function BooleanStatusIcon(props: BooleanStatusIconProps) {
    const { active, activeLabel, inactiveLabel } = props;

    const iconProps = active
        ? {
              Icon: CheckboxCircleLine,
              color: alertIconColors.success,
              message: activeLabel,
          }
        : {
              Icon: CheckboxBlankCircleLine,
              color: alertIconColors.neutral,
              message: inactiveLabel,
          };

    return (
        <Tooltip placement="top" content={iconProps.message} layout="inline">
            <SvgIcon
                icon={iconProps.Icon}
                size="custom"
                customSize="1.7em"
                color={iconProps.color}
            />
        </Tooltip>
    );
}
